import React, { useState } from "react";
import {
  Box,
  Container,
  Dialog,
  IconButton,
  Typography,
} from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Slider from "react-slick";
import { motion } from "framer-motion";
import { storiescoach } from "../../assets";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SlickSlider = Slider as unknown as React.FC<any>;

interface Testimonial {
  id: number;
  videoUrl: string;
}

const testimonials: Testimonial[] = [
  { id: 1, videoUrl: "https://dprstorage.b-cdn.net/rwWebinarVedios/video1.mp4" },
  { id: 2, videoUrl: "https://dprstorage.b-cdn.net/rwWebinarVedios/video2.mp4" },
  { id: 3, videoUrl: "https://dprstorage.b-cdn.net/rwWebinarVedios/video3.mp4" },
  { id: 4, videoUrl: "https://dprstorage.b-cdn.net/rwWebinarVedios/video4.mp4" },
  { id: 5, videoUrl: "https://dprstorage.b-cdn.net/rwWebinarVedios/video5.mp4" },
];

const NextArrow = (props: any) => {
  const { onClick } = props;
  return (
    <IconButton
      onClick={onClick}
      sx={{
        position: "absolute",
        right: "-20px",
        top: "45%",
        zIndex: 10,
        background: "#0f63a5",
        color: "#fff",
        "&:hover": { background: "#0c4e82" },
      }}
    >
      <ArrowForwardIosIcon />
    </IconButton>
  );
};

const PrevArrow = (props: any) => {
  const { onClick } = props;
  return (
    <IconButton
      onClick={onClick}
      sx={{
        position: "absolute",
        left: "-20px",
        top: "45%",
        zIndex: 10,
        background: "#0f63a5",
        color: "#fff",
        "&:hover": { background: "#0c4e82" },
      }}
    >
      <ArrowBackIosNewIcon />
    </IconButton>
  );
};

const VideoTestimonials: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [activeVideo, setActiveVideo] = useState("");

  const handleOpen = (video: string) => {
    setActiveVideo(video);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setActiveVideo("");
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    cssEase: "ease-in-out",
    centerMode: false,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 900,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <Box
      sx={{
        py: 10,
      }}
    >
      <Container maxWidth="lg">
        <Box textAlign="center" mb={6} color="white">
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h3"
              component="span"
              sx={{
                color: "#fff",
                fontSize: "50px",
                fontWeight: 700,
                letterSpacing: 2,
                mr: 1,
              }}
            >
              Still
            </Typography>

            <Typography
              variant="h1"
              sx={{
                background:
                  "linear-gradient(90deg, #ffffff 0%, #d4af37 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                position: "relative",
                display: "inline-block",
                fontWeight: 700,
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: "0px",
                  left: 0,
                  width: "100%",
                  height: "10px",
                  background: "rgb(177 177 177 / 50%)",
                  borderRadius: "4px",
                },
              }}
            >
              Evaluating?
            </Typography>
          </Box>

          <Typography sx={{ opacity: 0.8, color: "white" }}>
            Hear From Leaders Who Transformed Their Sales Performance Through
            Structured Systems
          </Typography>
        </Box>

        <Box
          sx={{
            px: { xs: 2, md: 4 },
            position: "relative",
            "& .slick-list": {
              overflow: "hidden",
            },
            "& .slick-slide": {
              padding: "0 10px",
              boxSizing: "border-box",
            },
            "& .slick-dots li button:before": {
              color: "#fff",
              fontSize: "10px",
            },
            "& .slick-dots li.slick-active button:before": {
              color: "#0f63a5",
            },
          }}
        >
          <SlickSlider {...settings}>
            {testimonials.map((item) => (
              <Box key={item.id}>
                <Box
                  sx={{
                    position: "relative",
                    borderRadius: "20px",
                    overflow: "hidden",
                    cursor: "pointer",
                  }}
                >
                  <video
                    src={item.videoUrl}
                    muted
                    loop
                    playsInline
                    style={{
                      width: "100%",
                      height: "400px",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />

                  <Box
                    onClick={() => handleOpen(item.videoUrl)}
                    sx={{
                      position: "absolute",
                      inset: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "0.3s",
                      "&:hover": {
                        background:
                          "linear-gradient(rgba(15,99,165,0.6), rgba(15,99,165,0.6))",
                      },
                    }}
                  >
                    <IconButton
                      sx={{
                        backgroundColor: "#fff",
                        width: 60,
                        height: 60,
                        "&:hover": {
                          transform: "scale(1.1)",
                        },
                      }}
                    >
                      <PlayArrowIcon
                        sx={{ color: "#0f63a5", fontSize: 35 }}
                      />
                    </IconButton>
                  </Box>
                </Box>
              </Box>
            ))}
          </SlickSlider>
        </Box>
      </Container>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth={false}
        PaperProps={{
          sx: { background: "transparent", boxShadow: "none" },
        }}
        BackdropProps={{
          sx: {
            backgroundColor: "rgba(0,0,0,0.7)",
            backdropFilter: "blur(6px)",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          {activeVideo && (
            <Box sx={{ position: "relative" }}>
              <IconButton
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  zIndex: 10,
                  backgroundColor: "rgba(0,0,0,0.6)",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "rgba(0,0,0,0.8)",
                  },
                }}
              >
                <CloseIcon />
              </IconButton>

              <motion.video
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.4 }}
                src={activeVideo}
                controls
                autoPlay
                style={{
                  height: "500px",
                  maxWidth: "90vw",
                  borderRadius: "20px",
                  boxShadow: "0 40px 100px rgba(0,0,0,0.7)",
                }}
              />
            </Box>
          )}
        </Box>
      </Dialog>
    </Box>
  );
};

export default VideoTestimonials;